import { render, staticRenderFns } from "./ldForgotDonorId.vue?vue&type=template&id=25120680&scoped=true"
import script from "./ldForgotDonorId.vue?vue&type=script&lang=js"
export * from "./ldForgotDonorId.vue?vue&type=script&lang=js"
import style0 from "./ldForgotDonorId.vue?vue&type=style&index=0&id=25120680&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25120680",
  null
  
)

export default component.exports